import classNames from "classnames";
import React, { HTMLAttributes } from "react";

import { colors } from "src/assets/styles/settings";
import { StyledPanelHeader } from "../Panel.styled";

type Props = HTMLAttributes<HTMLDivElement> & {
  borderColor: string;
};

const defaultProps = {
  borderColor: colors.main_background
};

const PanelHeader = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { children, className, borderColor } = props;
  const panelHeaderClass = classNames("c-panel__header", className);

  return (
    <StyledPanelHeader ref={ref} data-testid="qa-panel-header" className={panelHeaderClass} borderColor={borderColor}>
      {children}
    </StyledPanelHeader>
  );
});

PanelHeader.defaultProps = defaultProps;

export default PanelHeader;
